module.exports = __webpack_public_path__ + "assets/img/tips.afe6e5ea.png";